<template>
  <div v-if="orden">
    <a-modal
      v-model="visible"
      :title="
        `OS # ${orden.ordenId} - ${orden.clienteNombre} ${
          orden.clienteApellidos
        } - ${orden.celularCliente}`
      "
      :footer="null"
      @ok="handleOk"
    >
      <p
        v-if="orden.valor_restante"
        style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500"
      >
        Resta: ${{ orden.valor_restante | currency }}
      </p>
      <p
        v-else
        style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500"
      >
        Precio: ${{ orden.precio | currency }}
      </p>
      <a-radio-group v-model="tipo_pago">
        <a-radio
          :value="item.id"
          v-for="(item, k) in tipoPagos"
          :key="k"
        >
          {{ item.tipo }}
        </a-radio>
      </a-radio-group>

      <div style="padding-top: 15px">
        <label>Valor del pago</label>
        <money
          v-model="valor_pagado"
          class="form-control"
          :precision="0"
        ></money>
      </div>

      <div style="padding-top: 15px" v-if="tipo_pago === 4">
        <label>Ingrese el valor del abono</label>
        <money
          v-model="abono"
          class="form-control"
          :precision="0"
        ></money>
      </div>
      <div style="padding-top: 15px">
        <a-textarea
          v-model="observaciones"
          placeholder="En este campo puede colocar observaciones o notas de interés..."
          auto-size
        />
      </div>
      <div style="padding-top: 15px">
        <a-button
          @click="entregarPagar()"
          :loading="loading"
          type="primary"
        >
          Entregar
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { Money } from 'v-money';
import ServiceApi from '../../ServiceApi';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { Filters } from '../../mixins/index';
export default {
  name: 'modal-pago',
  mixins: [Filters],
  components: {
    Money,
  },
  props: {
    orden: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      observaciones: null,
      tipoPagos: [],
      visible: false,
      tipo_pago: null,
      valor_pagado: null,
      abono: 0,
    };
  },
  watch: {
    orden() {
      if (this.orden) {
        if (!this.orden.valor_restante) {
          this.valor_pagado = this.orden.precio;
        } else {
          this.valor_pagado = this.orden.valor_restante;
        }
      }
    },
  },
  created() {
    this.getTipoPagos();
  },
  methods: {
    handleOk(e) {
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    getTipoPagos() {
      ServiceApi.get('/get/tipo/pagos')
        .then(response => {
          this.tipoPagos = response.data.tipoPagos;
        })
        .catch(e => {});
    },
    entregarPagar() {
      if (!this.tipo_pago) {
        this.$noty.error('Debes seleccionar un tipo de pago.');
        return;
      } else if (
        this.tipo_pago === 4 &&
        (!this.abono || this.abono === 0)
      ) {
        this.$noty.error('El valor abonado es requerido.');
        return;
      }
      this.loading = true;
      ServiceApi.post('/entregar/pagar', {
        ordenId: this.orden.ordenId,
        tipo_pago_id: this.tipo_pago,
        valor_pagado: this.valor_pagado,
        valor_restante:
          this.tipo_pago === 4 ? this.orden.precio - this.abono : 0,
        observaciones: this.observaciones,
      })
        .then(response => {
          this.loading = false;
          this.showModal(this.orden.ordenId);
          this.$emit('onSuccess');
          this.visible = false;
        })
        .catch(e => {
          this.loading = false;
          this.$noty.error(
            'Ocurrió un error al procesar la solicitud, intenta nuevamente.'
          );
        });
    },
    showModal(ordenId) {
      Swal.fire({
        type: 'success',
        title: `Se acaba de generar la entrega de la orden # ${ordenId}`,
        showConfirmButton: false,
        timer: 3000,
      });
    },
  },
};
</script>
